import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import { Collapse, Divider, ListItemButton, Typography, useMediaQuery } from '@mui/material';
import "./styles.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faTimes } from '@fortawesome/free-solid-svg-icons';
import Search from '../Search';
import Acessibilidade from '../Accessibility';
import { DrawerLoginProps } from '../../interfaces/props/DrawerLoginProps';
import { sxDivider, sxDividerContrast, sxIconButton, sxListItemButton, sxListItemText, sxTypography } from './sxProps';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';

const DrawerLogin: React.FC<DrawerLoginProps> = ({ handleDrawerToggle, openLink, searchValue, setSearchValue }) => {
  const [openSubMenu, setOpenSubMenu] = useState<boolean>(false);

  const handleClickSubMenu = () => {
    setOpenSubMenu(!openSubMenu);
  };

  const { contrastMode, contrastStyle, textStyleAccessibility, buttonStyleAccessibility } = useAccessibility();

  return (
    <List className='container-drawer'>
      <div>
        <div className='container-drawer-search'>
          <Search openLink={openLink} setSearchValue={setSearchValue} searchValue={searchValue} />
          <IconButton style={buttonStyleAccessibility} sx={sxIconButton} onClick={handleDrawerToggle}>
            <FontAwesomeIcon icon={faTimes} />
          </IconButton>
        </div>
      </div>
      <div className={`margin-top-20 ${useMediaQuery('(max-width: 899px)') && 'margin-bottom-40'}`}>
        <Acessibilidade />
      </div>
      <Divider sx={contrastMode ? sxDividerContrast : sxDivider} />
      <ListItemButton onClick={() => openLink('institucional')}>
        <Typography style={textStyleAccessibility} sx={sxListItemText} >Institucional</Typography>
      </ListItemButton>
      <ListItemButton onClick={() => openLink('informativoComunicados')}>
        <Typography style={textStyleAccessibility} sx={sxListItemText}>Informativos e comunicados</Typography>
      </ListItemButton>
      <ListItemButton onClick={() => openLink('ouvidoria')}>
        <Typography style={textStyleAccessibility} sx={sxListItemText} >Ouvidoria</Typography>
      </ListItemButton>

      <ListItemButton onClick={handleClickSubMenu}>
        <Typography style={textStyleAccessibility} sx={sxTypography}>
          Canais
        </Typography>
        {!openSubMenu ? <FontAwesomeIcon style={contrastStyle} icon={faChevronDown} /> : <FontAwesomeIcon style={contrastStyle} icon={faChevronUp} />}
      </ListItemButton>

      <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton onClick={() => openLink('clientes')} sx={sxListItemButton}>
            <Typography style={textStyleAccessibility} sx={sxListItemText}>Clientes</Typography>
          </ListItemButton>
          <ListItemButton onClick={() => openLink('empresaClientes')} sx={sxListItemButton}>
            <Typography style={textStyleAccessibility} sx={sxListItemText}>Empresas Clientes</Typography>
          </ListItemButton>
          <ListItemButton onClick={() => openLink('medicosCooperados')} sx={sxListItemButton}>
            <Typography style={textStyleAccessibility} sx={sxListItemText}>Médicos Cooperados</Typography>
          </ListItemButton>
          <ListItemButton onClick={() => openLink('servicosCredenciados')} sx={sxListItemButton}>
            <Typography style={textStyleAccessibility} sx={sxListItemText}>Serviços Credenciados</Typography>
          </ListItemButton>
          <ListItemButton onClick={() => openLink('colaboradoresUnimed')} sx={sxListItemButton}>
            <Typography style={textStyleAccessibility} sx={sxListItemText}>Colaboradores Unimed</Typography>
          </ListItemButton>
          <ListItemButton onClick={() => openLink('fornecedoresOnline')} sx={sxListItemButton}>
            <Typography style={textStyleAccessibility} sx={sxListItemText} >Fornecedores Online</Typography>
          </ListItemButton>
          <ListItemButton onClick={() => openLink('res')} sx={sxListItemButton}>
            <Typography style={textStyleAccessibility} sx={sxListItemText}>RES</Typography>
          </ListItemButton>
          <ListItemButton onClick={() => openLink('aprovadorEletronico')} sx={sxListItemButton}>
            <Typography style={textStyleAccessibility} sx={sxListItemText}>Aprovador Eletrónico</Typography>
          </ListItemButton>
        </List>
      </Collapse >
    </List >
  );
}

export default DrawerLogin;
